import React, { Component, type ReactNode } from 'react';
import classnames from 'classnames';

import { TOAST_NOTIFICATIONS_TYPES } from 'dpl/shared/constants/shared';
import Icon from 'dpl/common/components/Icon';

const { ERROR, INFO, SUCCESS } = TOAST_NOTIFICATIONS_TYPES;

const ICON_CLASSNAMES = 'ba br-100  b--transparent padding-h-6 padding-v-6';
const ICON_SIZE = '32px';

export type ToastNotificationType =
  (typeof TOAST_NOTIFICATIONS_TYPES)[keyof typeof TOAST_NOTIFICATIONS_TYPES];

export interface ToastNotificationsListItemProps {
  message: ReactNode;
  type?: ToastNotificationType;
  showCloseButton?: boolean;
  onClose?: () => void;
}

interface ToastNotificationsListItemState {
  isVisible: boolean;
}

export default class ToastNotificationsListItem extends Component<
  ToastNotificationsListItemProps,
  ToastNotificationsListItemState
> {
  static defaultProps: Partial<ToastNotificationsListItemProps> = {
    type: INFO
  };

  state: ToastNotificationsListItemState = {
    isVisible: false
  };

  componentDidMount() {
    window.setTimeout(() => {
      this.setState({ isVisible: true });
    });
  }

  render() {
    const { message, type, showCloseButton, onClose } = this.props;

    const { isVisible } = this.state;

    return (
      <div
        className={classnames('ToastNotificationsListItem mb3 transition', {
          'o-0': !isVisible,
          'o-100': isVisible
        })}
      >
        <div className="pv3 ph3 br3 ba b--default bg-white relative">
          <div className="flex font-16 gap-12">
            {type === ERROR && (
              <Icon
                name="fetch-close"
                height={ICON_SIZE}
                width={ICON_SIZE}
                className={classnames(
                  ICON_CLASSNAMES,
                  'bg-rubber-500 rubber-light'
                )}
              />
            )}
            {type === SUCCESS && (
              <Icon
                name="fetch-success"
                height={ICON_SIZE}
                width={ICON_SIZE}
                className={classnames(
                  ICON_CLASSNAMES,
                  'bg-stroll-mid green-dark-700'
                )}
              />
            )}
            <div className="flex-auto self-center">{message}</div>
            {(type === ERROR || showCloseButton) && (
              <button
                onClick={onClose}
                type="button"
                className="self-start pointer"
              >
                <Icon
                  height="20px"
                  name="fetch-close"
                  width="20px"
                  className="secondary"
                />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
